import React from "react";
import { connect } from "react-redux";
import { Loading } from "../../Loader";
import "../styles.css";
import Empty from "../../Empty";
import language from "../../../language";
import { CardHeader } from "../../Header";
import { Line } from "react-chartjs-2";
import icons from "../../../constants/icons";
import { fetchTransactionsSummary } from "../../../queries/reports/transactionsQuery";
import reportFilters from "../../../queries/reports/reportFilters";

const options = {
  maintainAspectRatio: false,
  animation: false,
  offset: true,
};

const months = {
  1: "January",
  2: "February",
  3: "March",
  4: "April",
  5: "May",
  6: "June",
  7: "July",
  8: "August",
  9: "September",
  10: "October",
  11: "November",
  12: "December",
};

class Monthly extends React.Component {
  state = {
    isLoading: false,
    data: {},
  };

  componentDidMount() {
    this.getData(true);
  }

  componentDidUpdate(prevProps) {
    if (this.props.filters !== prevProps.filters) {
      this.getData(true);
    }
  }

  getData = async (isLoading) => {
    const { defaultLanguage, filters } = this.props;
    try {
      this.setState({ isLoading });

      const responseData = await fetchTransactionsSummary(
        defaultLanguage,
        await reportFilters(filters)
      );

      const chartData = await this.returnChartData(responseData.content);

      this.setState({
        data: chartData,
        isLoading: false,
      });
    } catch (error) {
      this.setState({
        isLoading: false,
      });
    }
  };

  returnChartData(data) {
    const chartData = [];
    data.forEach((item) => {
      const date = new Date(item.date);
      const month = date.getMonth() + 1;

      const key = months[month];

      if (!chartData[key]) {
        chartData[key] = 0;
      }

      chartData[key] += Math.round(item.amount);
    });

    return {
      labels: Object.keys(chartData),
      datasets: [
        {
          label: "Total Monthly Transactions",
          data: Object.values(chartData),
          backgroundColor: "#ffeded",
          borderColor: "#c21510",
          radius: 5,
        },
      ],
    };
  }

  render() {
    return (
      <div className="chart-container mb-3 mt-3">
        <div className="card">
          <div className="card-header">
            <div style={{ flex: 1 }}>
              <CardHeader title="Monthly Transactions" />
            </div>
          </div>
          <div className="card-body" style={{ height: 380 }}>
            {this.state.isLoading ? (
              <Loading />
            ) : this.state.data?.datasets?.length > 0 ? (
              <Line data={this.state.data} options={options} />
            ) : (
              <Empty
                title={language[this.props.defaultLanguage].no_data}
                icon={icons.chart}
              />
            )}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { defaultLanguage } = state.Language;
  const { filters } = state.Filters;
  return {
    defaultLanguage,
    filters,
  };
};

export default connect(mapStateToProps)(Monthly);
